import type { RouteConnectionWithDetails } from '@sembo-private/maps';

import { getHumanizedDuration } from '@apps/main/modules/helpers/formatting';
import type { UserLocation } from '@apps/main/new-desktop/core/models';
import type { EditTripSegment } from '@apps/main/new-desktop/modules/editTripModal';

import { createIngredientId } from '@libs/trip-planner-interfaces';

import type { CarTripInfo } from '../models';

export function getStartingLocationSegment(
  location: UserLocation,
  calculatedRoute?: RouteConnectionWithDetails
): EditTripSegment {
  let carTripInfo: CarTripInfo | undefined;
  if (
    calculatedRoute?.distanceInKilometers &&
    calculatedRoute.expectedTravelTimeInMinutes
  ) {
    carTripInfo = {
      distance: `${calculatedRoute.distanceInKilometers.toFixed()}km`,
      duration: getHumanizedDuration(
        calculatedRoute.expectedTravelTimeInMinutes,
        'minute'
      ),
    };
  }
  const destinationName = location.country
    ? `${location.name}, ${location.country}`
    : location.name;
  return {
    destinationName,
    numberOfNights: undefined,
    ingredientId: createIngredientId('starting-position'),
    carTripInfo,
  };
}

export function getEndLocationSegment(location: UserLocation): EditTripSegment {
  const destinationName = location.country
    ? `${location.name}, ${location.country}`
    : location.name;
  return {
    destinationName,
    numberOfNights: undefined,
    ingredientId: createIngredientId('end-position'),
  };
}
